var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({tag:"component",staticClass:"stac-link",attrs:{"title":_vm.tooltip}},'component',_vm.attributes,false),[(_vm.icon)?[_c('img',{staticClass:"icon mr-2",attrs:{"src":_vm.icon.href,"alt":_vm.icon.title,"title":_vm.icon.title}})]:_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.displayTitle))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }